module.exports = "/_next/static/images/CustomerStoryIbm-ff67c5ff00a4c4d81d46515039d6f6d7.png";